import { Platform } from 'react-native';

const QRCode = Platform.select({
  //ios: () => require('react-native-qrcode-svg'),
  //android: () => require('react-native-qrcode-svg'),
  web: () => require('react-qr-code').default,
})();

export default QRCode;
